import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AdjustmentTypeStore } from '../service/adjustment-type/adjustment-type.store';
import { Observable } from 'rxjs/Observable';
import { AdjustmentType } from '../models/adjustment-type';

@Injectable()
export class AdjustmentTypeDebitResolver implements Resolve<AdjustmentType[]> {

  constructor(private adjustmentTypeStore: AdjustmentTypeStore) { }

  resolve(): Observable<AdjustmentType[]> {
    return this.adjustmentTypeStore.loadDebitAdjustmentTypes();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/adjustment-type-debit.resolver.ts